export default __webpack_public_path__ + "static/media/default.fcd044049592579f79acc6fbb8abb2f7.png";